module.exports = __webpack_public_path__ + "static/media/download.797ae2f0.svg";